import React from 'react'
import { connect } from 'react-redux'

import {
  updateAnonymousUserEmailAsync,
  removeAnonymousUserEmailAsync
} from './anonymousUserEmailActions'

import {
  CheckoutSection,
} from '../../components'

import {
  hiddenAnchorStyle
} from '../../components/styles'
import { TranslationUtility } from "../../../util/translationUtility";

class CheckoutAnonymousUserEmail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedAnonymousUserEmail: props.anonymousUserEmail
    };
    this.onClickChange = this.onClickChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.translationUtility = new TranslationUtility(props.localizationItems);
  }

  onClickChange(e) {
    e.preventDefault();
    this.props.onClear();
  }

  onSubmit(e) {
    e.preventDefault();
    const {
      editedAnonymousUserEmail
    } = this.state;
    this.props.onSave(editedAnonymousUserEmail);
  }

  render() {
    const {
      editedAnonymousUserEmail
    } = this.state;
    const {
      onSave,
      anonymousUserEmail,
      setAnonymousUserEmail,
      userIsAnonymous
    } = this.props;
    return (
      <div>
        {userIsAnonymous &&
          <CheckoutSection label={this.translationUtility.translateResourceString("/Checkout/Email")} hidden={false}>
            {setAnonymousUserEmail &&
              <div style={{ lineHeight: 2 }}>
                <a
                  href=""
                  style={hiddenAnchorStyle}
                  onClick={this.onClickChange}
                >
                  {anonymousUserEmail}
                  <span style={{ marginLeft: 20, color: '#003057' }}>
                    Change
              </span>
                </a>
              </div>}
            {!setAnonymousUserEmail &&
              <div>
                <form onSubmit={this.onSubmit}>
                  <input
                    name="checkout-email"
                    type="text"
                    className="form-control"
                    value={editedAnonymousUserEmail}
                    style={{ display: 'inline', width: '200px' }}
                    onChange={(e) => this.setState({ editedAnonymousUserEmail: e.target.value })}
                  />
                  <span
                    onClick={() => onSave(editedAnonymousUserEmail)}
                    style={{ marginLeft: '20px' }}
                  >
                            {this.translationUtility.translateResourceString("/Checkout/Save")}
              </span>
                </form>
              </div>
            }
          </CheckoutSection>
        }
      </div>
    )
  }
}

const mapAnonymousUserEmailStateToProps = (state) => {
  return {
    setAnonymousUserEmail: state.entities.AnonymousUserEmail
      ? true
      : false,
    anonymousUserEmail: state.entities.AnonymousUserEmail,
    userIsAnonymous: state.constants.UserIsAnonymous,
    localizationItems: state.constants.localizationItems
  }
}

const mapAnonymousUserEmailDispatchToProps = (dispatch) => {
  return {
    onSave: (anonymousUserEmail) => dispatch(updateAnonymousUserEmailAsync({ AnonymousUserEmail: anonymousUserEmail })),
    onClear: () => dispatch(removeAnonymousUserEmailAsync()),
  }
}

const CheckoutAnonymousUserEmailContainer = connect(mapAnonymousUserEmailStateToProps, mapAnonymousUserEmailDispatchToProps)(CheckoutAnonymousUserEmail);

export default CheckoutAnonymousUserEmailContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/AnonymousUserEmail/AnonymousUserEmail.jsx